export default __webpack_public_path__ + "static/Inter-SemiBold-c6588ec1e3a1f399c5c0ddab71a0caba.ttf";